require('../../modules/es.array.fill');

module.exports = require('../../internals/entry-unbind')('Array', 'fill');
